import React from 'react';
import { Label } from './ui/label';
import { AutoTextarea } from './ui/auto-textarea';

interface IntentTextareaProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  required?: boolean;
  className?: string;
}

const PROMPT_HINTS = [
  'Target audience and their main problem',
  'MVP features or initial product scope',
  'Expected timeline and budget range',
  'How this domain fits your brand vision',
  "Competitive advantage you're building",
];

export default function IntentTextarea({
  value,
  onChange,
  onBlur,
  error,
  required = true,
  className = '',
}: IntentTextareaProps) {
  return (
    <div className={`space-y-2 ${className}`}>
      <Label htmlFor="intent" className="text-sm font-medium">
        What will you build with this domain?{' '}
        {required && <span className="text-destructive">*</span>}
      </Label>
      <p className="text-xs text-muted-foreground mb-3">
        We review for TOS compliance and to prepare your 1-hour consult. Be specific about your
        plans.
      </p>

      <AutoTextarea
        id="intent"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder="Describe your project, target audience, timeline, and how this domain will help your business..."
        className={`min-h-[100px] ${error ? 'border-destructive' : ''}`}
        required={required}
        aria-describedby={error ? 'intent-error' : 'intent-hints'}
      />

      {error && (
        <p id="intent-error" className="text-xs text-destructive">
          {error}
        </p>
      )}

      <div id="intent-hints" className="mt-3">
        <p className="text-xs text-muted-foreground mb-2">Consider including:</p>
        <ul className="text-xs text-muted-foreground space-y-1">
          {PROMPT_HINTS.map((hint, index) => (
            <li key={index} className="flex items-start gap-1">
              <span className="text-primary">•</span>
              {hint}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
